// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"826":"user-rights-roles","893":"login-home-welcome"}[chunkId] || chunkId) + "." + {"413":"b992ce44","826":"9c2c1e40","893":"242d7d7f"}[chunkId] + ".js";
};